import { render, staticRenderFns } from "./MyLastSearchTerms.vue?vue&type=template&id=25f328ce&scoped=true"
import script from "./MyLastSearchTerms.vue?vue&type=script&lang=ts"
export * from "./MyLastSearchTerms.vue?vue&type=script&lang=ts"
import style0 from "./MyLastSearchTerms.vue?vue&type=style&index=0&id=25f328ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f328ce",
  null
  
)

export default component.exports